export default __webpack_public_path__ + "static/media/appointment-icon.b94ea3f7.svg";